'use client';

import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

type FiltersDesktopHeaderProps = {
  count?: number;
  clearFilters: () => void;
  className?: string;
};

export const FiltersDesktopHeader = ({
  count = 0,
  clearFilters,
  className,
}: FiltersDesktopHeaderProps) => {
  return (
    <div className={cn('flex items-center justify-between py-5', className)}>
      <h2 className='py-0 text-xl font-bold text-brand-dark'>
        Filters
        {count > 0 && (
          <span className='ml-2 text-sm text-muted-foreground'>({count})</span>
        )}
      </h2>
      <Button
        className='pr-0 text-primary hover:text-brand-dark'
        onClick={clearFilters}
        variant='transparent'
        size='sm'
      >
        Reset All
      </Button>
    </div>
  );
};
